import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase.config';

const PatientProtectedRoute = ({ children }) => {
  const [authReady, setAuthReady] = useState(!!auth.currentUser);

  useEffect(() => {
    if (authReady) return;
    const unsubscribe = onAuthStateChanged(auth, () => {
      setAuthReady(true);
    });
    return unsubscribe;
  }, [authReady]);

  const userProfile = localStorage.getItem('UserProfile');
  const loginStatus = localStorage.getItem('UserLoginStatus');

  // Wait for Firebase Auth to rehydrate from IndexedDB before deciding
  if (!authReady) {
    return <div className="loader-container"><div className="spinner-border text-primary" role="status"><span className="visually-hidden">Loading...</span></div></div>;
  }

  // Require both localStorage markers AND a live Firebase Auth session.
  if (!userProfile || loginStatus !== 'true' || !auth.currentUser) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default PatientProtectedRoute;
